import { Component, Input } from '@angular/core';
import { BehavioralFactorRanges } from '../../core-data-model/BehavioralFactorRanges.model';
import { config, DragStartEndMap } from './BehavioralRanges.interface';
import { BehavioralRangesUtil } from './BehavioralRanges.util';

@Component({
    selector: '[behavioralRangesRectangles]',
    template: `
        @for (
            dimensionData of getFactorRangesDimensionsData();
            track trackBySVGProps(i, dimensionData);
            let i = $index
        ) {
            <svg:g>
                @if (validInputRanges()) {
                    <svg:rect
                        [attr.x]="dimensionData.rectStartEnd.start"
                        [attr.y]="dimensionData.rectY"
                        [attr.width]="dimensionData.rectWidth"
                        [attr.height]="config.rectHeight"
                        [attr.sigmaMin]="dimensionData.minMax.min"
                        [attr.sigmaMax]="dimensionData.minMax.max"
                        rx="4"
                        ry="4"
                        [ngStyle]="style"
                    />
                }
            </svg:g>
        }
    `,
    standalone: false
})
export class BehavioralRangesRectanglesComponent {
    @Input('behavioralRangesRectangles')
    ranges: BehavioralFactorRanges;
    @Input()
    dragMap: DragStartEndMap;
    @Input()
    highlighted = false;
    @Input()
    useRangeRectThickStyle = false;

    config = config;

    get style() {
        if (this.highlighted) {
            return Object.assign({}, this.config.rangeRectStyle, {
                stroke: 'blue'
            });
        }

        if (this.useRangeRectThickStyle) {
            return Object.assign({}, this.config.rangeRectStyle, {
                strokeWidth: 6.0
            });
        } else {
            return this.config.rangeRectStyle;
        }
    }

    validInputRanges(): boolean {
        return BehavioralRangesUtil.validInputRanges(this.ranges);
    }

    /**
     * Get all the relevant data to draw the factor ranges.
     */
    getFactorRangesDimensionsData() {
        return BehavioralRangesUtil.getFactorRangesDimensionsData(
            BehavioralRangesUtil.factors,
            this.dragMap || ({} as any),
            !!this.dragMap,
            this.ranges
        );
    }

    trackBySVGProps(i: number, data: any) {
        return data.rectWidth + data.rectY;
    }
}
